import React from 'react';

const IconLaptop: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    height='16'
    width='16'
    viewBox='0 0 640 512'
    focusable='false'
    role='presentation'
    data-icon-credit='Laptop by Font Awesome - https://fontawesome.com/icons/laptop?style=brands'
    {...props}
    className={`icon icon-laptop${props.className ? ' ' + props.className : ''}`}
  >
    <path
      d='M128 32C92.7 32 64 60.7 64 96l0 256 64 0 0-256 384 0 0 256 64 0 0-256c0-35.3-28.7-64-64-64L128 32zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480l486.4 0c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2L19.2 384z'
      fill=''
    ></path>
  </svg>
);
export default IconLaptop;
